// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHsaBalanceMonthlyRecord } from './IHsaBalanceMonthlyRecord';
import {
    IHsaBalanceMonthlyRecordFromJSON,
    IHsaBalanceMonthlyRecordFromJSONTyped,
    IHsaBalanceMonthlyRecordToJSON,
    IHsaBalanceMonthlyRecordToJSONTyped,
} from './IHsaBalanceMonthlyRecord';

/**
 * 
 * @export
 * @interface IHsaPlanBalanceMonthlyBreakdownResponseDto
 */
export interface IHsaPlanBalanceMonthlyBreakdownResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IHsaPlanBalanceMonthlyBreakdownResponseDto
     */
    current_cash_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaPlanBalanceMonthlyBreakdownResponseDto
     */
    current_investment_balance?: number;
    /**
     * 
     * @type {Array<IHsaBalanceMonthlyRecord>}
     * @memberof IHsaPlanBalanceMonthlyBreakdownResponseDto
     */
    monthly_breakdown?: Array<IHsaBalanceMonthlyRecord>;
}

/**
 * Check if a given object implements the IHsaPlanBalanceMonthlyBreakdownResponseDto interface.
 */
export function instanceOfIHsaPlanBalanceMonthlyBreakdownResponseDto(value: object): value is IHsaPlanBalanceMonthlyBreakdownResponseDto {
    return true;
}

export function IHsaPlanBalanceMonthlyBreakdownResponseDtoFromJSON(json: any): IHsaPlanBalanceMonthlyBreakdownResponseDto {
    return IHsaPlanBalanceMonthlyBreakdownResponseDtoFromJSONTyped(json, false);
}

export function IHsaPlanBalanceMonthlyBreakdownResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaPlanBalanceMonthlyBreakdownResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'current_cash_balance': json['current_cash_balance'] == null ? undefined : json['current_cash_balance'],
        'current_investment_balance': json['current_investment_balance'] == null ? undefined : json['current_investment_balance'],
        'monthly_breakdown': json['monthly_breakdown'] == null ? undefined : ((json['monthly_breakdown'] as Array<any>).map(IHsaBalanceMonthlyRecordFromJSON)),
    };
}

export function IHsaPlanBalanceMonthlyBreakdownResponseDtoToJSON(json: any): IHsaPlanBalanceMonthlyBreakdownResponseDto {
    return IHsaPlanBalanceMonthlyBreakdownResponseDtoToJSONTyped(json, false);
}

export function IHsaPlanBalanceMonthlyBreakdownResponseDtoToJSONTyped(value?: IHsaPlanBalanceMonthlyBreakdownResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_cash_balance': value['current_cash_balance'],
        'current_investment_balance': value['current_investment_balance'],
        'monthly_breakdown': value['monthly_breakdown'] == null ? undefined : ((value['monthly_breakdown'] as Array<any>).map(IHsaBalanceMonthlyRecordToJSON)),
    };
}

